import { render } from "./MemoryWidget.vue?vue&type=template&id=c35d8f56&scoped=true"
import script from "./MemoryWidget.vue?vue&type=script&lang=js"
export * from "./MemoryWidget.vue?vue&type=script&lang=js"

import "./MemoryWidget.vue?vue&type=style&index=0&id=c35d8f56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c35d8f56"],['__file',"src/components/MemoryWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c35d8f56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c35d8f56', __exports__)) {
    api.reload('c35d8f56', __exports__)
  }
  
  module.hot.accept("./MemoryWidget.vue?vue&type=template&id=c35d8f56&scoped=true", () => {
    api.rerender('c35d8f56', render)
  })

}


export default __exports__